export const SAVE_TYPES = {
  AUTO: 'auto',
  MANUAL: 'manual',
  EXTERNAL_CONNECTION: 'external_connection',
}
